import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import { formatErr } from "@/lib/auth";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) { setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] fl-noise flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-10 flex justify-center">
          <Logo variant="wordmark" size="lg" />
        </Link>
        <div className="fl-card p-8">
          <h1 className="fl-heading text-3xl">Reset your password</h1>
          {!sent ? (
            <>
              <p className="text-zinc-400 mt-2 text-sm">Enter your email and we'll send you a reset link.</p>
              <form onSubmit={submit} className="mt-8 space-y-4">
                <div>
                  <div className="fl-label mb-2">Email</div>
                  <input className="fl-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="fp-email" />
                </div>
                {err && <div className="text-sm text-red-400">{err}</div>}
                <button className="fl-btn w-full justify-center" disabled={loading} data-testid="fp-submit">{loading ? "Sending…" : "Send reset link"}</button>
              </form>
            </>
          ) : (
            <div className="mt-6">
              <div className="fl-heading text-xl text-[#f47a20]">Check your inbox</div>
              <p className="text-zinc-400 mt-3 text-sm">If an account exists for <span className="text-white">{email}</span>, we've sent a password-reset link. The link expires in 1 hour.</p>
            </div>
          )}
          <div className="mt-6 text-sm text-zinc-400 text-center">
            <Link to="/login" className="text-[#f47a20]">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
